namespace TabAurous.Administration {
    export interface ItemDiscountForm {
        Code: Serenity.StringEditor;
        Details: ItemDiscountDetailsEditor;
    }

    export class ItemDiscountForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.ItemDiscount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ItemDiscountForm.init)  {
                ItemDiscountForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ItemDiscountDetailsEditor;

                Q.initFormType(ItemDiscountForm, [
                    'Code', w0,
                    'Details', w1
                ]);
            }
        }
    }
}
